import { useEffect, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { setTimeoutResetCallback } from '../../helpers/interceptor';
import { secureLogout } from '../../helpers/tokenSecurity';

const TIMEOUT_DURATION = (process.env.REACT_APP_SESSION_TIMEOUT_MINUTES || 15) * 60 * 1000;
console.log("TIMEOUT_DURATION",TIMEOUT_DURATION);

export const useSessionTimeout = () => {
  const { instance } = useMsal();
  const timeoutRef = useRef(null);
  const activeRequestsRef = useRef(0);


  const clearCurrentTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const logout = async () => {
    await secureLogout(instance);
  };

  const resetTimeout = () => {
    clearCurrentTimeout();
    if (activeRequestsRef.current === 0) {
      timeoutRef.current = setTimeout(logout, TIMEOUT_DURATION);
    }
  };

  const pauseTimeout = () => {
    activeRequestsRef.current++;
    clearCurrentTimeout();
  };

  const resumeTimeout = () => {
    activeRequestsRef.current = Math.max(0, activeRequestsRef.current - 1);
    if (activeRequestsRef.current === 0) {
      resetTimeout();
    }
  };



  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    
    events.forEach(event => {
      document.addEventListener(event, resetTimeout, true);
    });

    setTimeoutResetCallback({ resetTimeout, pauseTimeout, resumeTimeout });
    resetTimeout();

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, resetTimeout, true);
      });
      setTimeoutResetCallback(null);
      clearCurrentTimeout();
    };
  }, []);
};